import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

function YourDataDeliveryAddress(props) {
  const { information } = props;
  const {
    company,
    street,
    town,
    zipcode,
    country: { label },
  } = information;
  return (
    <>
      <FormattedMessage id="offerWizard.yourData.deliveryAddress" />
      <br />
      {company}
      <br />
      {street}
      <br />
      {zipcode} {town}
      <br />
      {label}
    </>
  );
}

YourDataDeliveryAddress.propTypes = {
  information: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default YourDataDeliveryAddress;
